/** @enum {string} */
export const CategoryTypes = {
    /** Use for package item */
    Package: 'package',
    /** Use for device item */
    Device: 'console',
    /** Use for any other item */
    Shipping: 'shipping',
    AccessCard: 'accesscard',
    Trial: 'trial'
};


// WEBPACK FOOTER //
// ./src/app/shared/ecommerce/enums/categoryTypes.ts